import 'twin.macro'

import React, { FC } from 'react'
import tw, { TwStyle } from 'twin.macro'

type SubBodyProps = {
  children: React.ReactNode
  variant?: 'bold' | 'regular' | 'medium'
  twStyle?: TwStyle
}
const textVariants = {
  bold: tw`font-bold`,
  regular: tw`font-normal`,
  medium: tw`font-medium`
} as { bold: TwStyle; regular: TwStyle; medium: TwStyle }

const styles = {
  text: ({ variant = 'regular', twStyle }: { variant?: 'bold' | 'regular' | 'medium'; twStyle?: TwStyle }) => [
    tw`text-s14`,
    textVariants[variant],
    twStyle
  ]
}

export const SubBody: FC<SubBodyProps> = ({ children, variant, twStyle }) => {
  return <span css={styles.text({ variant, twStyle })}>{children}</span>
}
export default SubBody
